import { projectCreateActionUrlBuilder } from "@/lib/url-builder";
import { Project, ProjectService } from "@/services/ProjectService";
import { useEffect, useState } from "react";
import {  useOutletContext, useParams } from "react-router";
import type { LayoutContext } from "@/lib/models";
import ActionCardGridView from "@/components/actions/ActionCardGridView";
import { Action, ActionService } from "@/services/ActionService";

const ProjectActionsPage: React.FC = () => {
  const { setPageName } = useOutletContext<LayoutContext>();
  const params = useParams();
  const [project, setProject] = useState(new Project("", "", params.siteId!, params.tenantId!, "68b4704749b0f309d2a4af2a", "68b4770949b0f309d2a4af39", 0, 0, null, null))
  const [actionsList, setActionsList] = useState<Action[]>([]);
  
  useEffect(() => {
    const initPage = async () => {
      const project = await ProjectService.getById(params.projectId!)
      const actions = await ActionService.getByProjectId(params.projectId!)
      setActionsList(actions)
      setProject(project)
      setPageName(`Tasks ${project.name}`) // Set the page name when the component mounts
    }
    initPage()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

    return (
    <div className="container mx-auto p-4">
      <ActionCardGridView actionsList={actionsList} title={`Project: ${project.name}`} createUrl={projectCreateActionUrlBuilder(params.tenantId!, params.siteId!, project.id)} />
    </div>)
}

export default ProjectActionsPage;
